
import { Component, Prop, Vue } from "vue-property-decorator";
import { SMUser } from "@/store";

const CLASS = "guide-card";

const ICONS = {
  lock: "lock-closed",
};

@Component
export default class GuideCard extends Vue {
  @Prop({ type: String, required: true }) readonly guide_alias!: string;
  @Prop({ type: String, required: true }) readonly name!: string;
  @Prop({ type: Number, required: true }) readonly ID!: number;
  @Prop({ type: Boolean, default: false }) readonly disabled?: boolean;

  icons = ICONS;

  get image() {
    let src = this.disabled
      ? require(`/src/assets/images/guides/library-disabled.svg`)
      : require(`/src/assets/images/guides/library.svg`);

    try {
      src = this.disabled
        ? require(`/src/assets/images/guides/${this.name}-disabled.svg`)
        : require(`/src/assets/images/guides/${this.name}.svg`);
    } catch (e) {
      console.log(`icon not found: ${this.name}`);
    }

    return {
      src,
      alt: this.name,
    };
  }

  get classes() {
    const { disabled } = this;

    return {
      [`${CLASS}_disabled`]: disabled,
    };
  }

  goToGuide(id: number) {
    if (this.disabled) return;

    const path = SMUser.basePath === "/" ? `/guide/${id}` : `${SMUser.basePath}/guide/${id}`;

    this.$router.push(path);
  }
}
